import type { ProjectTokenHeaders } from '@octopus-do/octopus-api-client'
import type { ID } from '@octopus-do/octopus-project-core'
import { projectUsersActions } from '@store/reducers/manager/users/actions'
import type { ProjectUser } from '@store/reducers/manager/users/types'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'

// Кто может стоять под комментарием: участники проекта, команда и все, кто
// писал в проекте. Сессия здесь не всегда есть — гость на шаренной ссылке и
// PDF-экспорт предъявляют свой токен заголовком.
const buildTokenHeaders = (id: ID): ProjectTokenHeaders => {
  const exportToken = localStorage.getItem('export_token')
  const passwordToken = localStorage.getItem(`pw_${id}`)

  return {
    ...(exportToken ? { 'x-export-token': exportToken } : {}),
    ...(passwordToken ? { 'x-password-token': passwordToken } : {}),
  }
}

export function* fetchUsers({
  payload: { id },
}: ReturnType<typeof projectUsersActions.fetchUsersSaga>) {
  try {
    const users: ProjectUser[] = yield call(
      NestClient.projects.recipients,
      id,
      buildTokenHeaders(id)
    )

    yield put(projectUsersActions.addUsers(users))
  } catch (error) {
    // Имена авторов — украшение поверх комментариев: без них проект открывается,
    // поэтому ошибка сюда и остаётся.
    console.error('Error fetching project users:', error)
  }
}
